import React from 'react';
import { twMerge } from 'tailwind-merge';

interface BareBuilderSectionProps extends React.HTMLAttributes<HTMLElement> {
  bgClassNames?: string;
  className?: string;
}

const BareBuilderSection: React.FC<BareBuilderSectionProps> = ({
  bgClassNames = '',
  className = '',
  children = null,
  ...props
}) => (
  <section className={twMerge('w-full', bgClassNames)} {...props}>
    <div className={className}>{children}</div>
  </section>
);

export default BareBuilderSection;
